<script>
import { mapGetters } from 'vuex'
import EmptyProfile from '@/components/profile/EmptyProfile.vue'
import CreditBalance from '@/components/credit/CreditBalance.vue'
// import CreditCharge from '@/components/credit/CreditCharge.vue'
import VoucherInput from '@/components/credit/voucher/VoucherInput.vue'
export default {
  name: 'Credit',
  components: {
    EmptyProfile,
    CreditBalance,
    // CreditCharge,
    VoucherInput
  },
  data: () => ({
    loading: true
  }),
  computed: {
    ...mapGetters(['hasCustomerNumber', 'locale'])
  },
  created: function() {
    this.loading = false
  }
}
</script>
<template>
  <v-card flat tile color="transparent" class="pa-4">
    <v-card-title class="justify-center mb-5">
      <span class="headline text-center primary--text">
        {{ $t('component.profile.tabs.creditTab.credit.header') }}
      </span>
    </v-card-title>
    <v-card-subtitle v-if="!loading && hasCustomerNumber" class="text-center"
    ><CreditBalance
      :content="$t('component.profile.tabs.creditTab.info.credit')"
    ></CreditBalance
    ></v-card-subtitle>
    <v-card-text>
      <EmptyProfile v-if="!hasCustomerNumber">
        {{ $t('component.profile.tabs.creditTab.empty.profile.alert') }}
      </EmptyProfile>
      <v-row v-else align="center" justify="center">
        <v-col cols="12" md="6">
          <v-skeleton-loader
            v-if="loading"
            class="mx-auto"
            max-width="300"
            type="heading,list-item-three-line">
          </v-skeleton-loader>
          <!--          <CreditCharge v-else class="mb-4" />-->
          <VoucherInput />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
